window.app.directive("msAutofocus", [
  "$timeout",
  function($timeout) {
    return {
      restrict: "A",
      link: function($scope, $element) {
        $timeout(function() {
          $element[0].focus();
        });
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/directives/msAutofocus.js